// conversations: the feed, messages, the composer, threads, cards, files (R10-Q16).
export const chat = {
  // The conversation's header and its menus.
  rename: "Rename",
  chatName: "Chat name",
  searchChannel: "Search this channel",
  searchConversation: "Search this conversation",
  searchFailed: "Couldn't search just now.",
  searching: "Searching…",
  nothingFound: "Nothing found.",
  notifications: "Notifications",
  notificationsTitle: "Notifications: {level}",
  levelAll: "All messages",
  levelAllHint: "Everything that would reach you",
  levelMentions: "Mentions only",
  levelMentionsHint: "@you, your team, @everyone, your threads",
  levelNone: "Nothing",
  levelNoneHint: "The badge only",
  levelAllToast: "All messages from here",
  levelMentionsToast: "Only mentions and your threads from here",
  levelNoneToast: "Nothing from here: the badge only",
  // `{phrase}` is the bold "off the record" (the words the server looks for stay English).
  listening: "Vantage listens here for team memory. Start a message with {phrase} to skip it.",
  manage: "Manage",
  channelSettings: "Channel settings",
  everyoneAtBusyCube: "Everyone at Busy Cube",
  teamName: "{name} team",
  members_one: "{n} member",
  members_other: "{n} members",
  membersLabel: "Members",
  needsAttention: "{n} needs attention",
  teamNotes: "Team notes",
  files: "Files",
  directMessage: "Direct message",
  online: "Online",
  away: "Away",
  offline: "Offline",
  markUnread: "Mark as unread",
  markedUnread: "Marked as unread",
  hideConversation: "Hide conversation",
  hiddenUntilNext: "Hidden until the next message",
  pin: "Pin",
  unpin: "Unpin",
  pinTitle: "Pin to the top",
  pinnedTitle: "Pinned: first in your direct messages",
  newChat: "New chat",
  renameChat: "Rename chat",
  pinChat: "Pin chat",
  unpinChat: "Unpin chat",
  archiveChat: "Archive chat",
  chatArchived: "Chat archived",
  restoreChat: "Restore chat",
  chatRestored: "Chat restored",
  deleteChat: "Delete chat",
  deleteChatTitle: "Delete this chat?",
  deleteChatBody:
    "“{title}” is erased: its messages, Vantage's answers, and the files and reports in it. This can't be undone once the next few seconds pass.",
  alsoForget: "Also forget what Vantage learned about you here",
  chatDeleted: "Chat deleted",
  chatDeleteFailed: "The chat couldn't be deleted.",
  chatsArchiveFailed: "The chats couldn't be archived.",
  chatsDeleteFailed: "The chats couldn't be deleted.",
  chatsBusy_one: "{n} chat couldn't be changed while Vantage is answering.",
  chatsBusy_other: "{n} chats couldn't be changed while Vantage is answering.",
  privateChat: "Private chat with Vantage",
  archivedPrivateChat: "Archived · private chat with Vantage",
  inbox: "Inbox",
  relaySub: "Your replies go back to them · start with “Vantage,” to ask Vantage",
  fromInbox: "From your Inbox",

  // The conversation page.
  conversation: "Conversation",
  conversationGone: "This conversation isn't available",
  conversationGoneBody: "It may have been removed, or you're not in it.",
  backToChat: "Back to Chat",
  whatThisConversation: "this conversation",
  whatMessages: "the messages",
  channelAria: "#{slug} channel",
  conversationWith: "Conversation with {name}",
  inboxConversation: "Inbox conversation",
  // `{link}` is "Unarchive the team" (a link for an admin).
  readOnlyBanner: "Archived team channel · read-only. {link} to bring its members back.",
  unarchiveTeam: "Unarchive the team",
  messageGone: "That message isn't here any more.",
  newerFailed: "Couldn't load newer messages.",
  mentionVantageSub: "the AI teammate",
  mentionEveryoneSub: "everyone here",
  editFirst: "Send or clear what you're writing first, then edit.",
  editingMessage: "Editing your message",
  editingLast: "Editing your last message · the answer will be redone",
  reply: "Reply",
  messageTo: "Message {name}",
  writeReply: "Write a reply…",
  askFollowUp: "Ask a follow-up…",
  messageToShared: "Message {name} — @Vantage to ask the agent",
  askAnything: "Ask Vantage anything…",
  relayHint:
    "Your reply is passed back where they asked (a channel's members see it there) · Start with “Vantage,” to ask Vantage instead",
  sharedHint: "@ to mention people · # for tickets · Enter to send · Shift+Enter for a new line",

  // The composer.
  composerHint: "Enter to send · Shift+Enter for a new line · Esc stops Vantage",
  composerDown: "The message box couldn't load. Check the connection, then reload the page.",
  noFilesWhileEditing: "Files can't be added while you edit a message.",
  askForReport: "Ask for a report…",
  didntSend: "That didn't send. Try again.",
  dropFiles: "Drop files to attach",
  suggestions: "Suggestions",
  uploading: "Uploading {name}",
  removeFile: "Remove {name}",
  attachFiles: "Attach files",
  mentionSomeone: "Mention someone",
  goDeep: "Go deep",
  goDeepTitle: "Let Vantage take its time and dig deep",
  send: "Send",

  // The feed.
  olderFailed: "Couldn't load older messages.",
  today: "Today · {date}",
  yesterday: "Yesterday · {date}",
  newDivider: "New",
  jumpLatest: "Jump to latest",

  // The side panel: a thread.
  thread: "Thread",
  threadAndNotes: "Thread and team notes",
  sidePanel: "Side panel",
  summarize: "Summarize",
  summarizeThread: "Summarize thread",
  summaryFailed: "Couldn't ask for a summary.",
  closePanel: "Close panel",
  closeThread: "Close thread",
  muteThread: "Mute thread",
  unmuteThread: "Unmute thread",
  muteTitle: "Mute this thread: badge only, no notifications",
  mutedTitle: "Muted: badge only",
  threadMuted: "Thread muted: you'll only see the badge",
  threadUnmuted: "Thread notifications on",
  couldntChange: "Couldn't change that just now.",
  replyGone: "That reply isn't here any more.",
  whatThreadRoot: "the thread's first message",
  whatReplies: "the replies",
  replies_one: "{n} reply",
  replies_other: "{n} replies",
  editingReply: "Editing your reply",
  replyInThread: "Reply in thread",
  replyInThreadPlaceholder: "Reply in thread…",

  // The side panel: files.
  closeFiles: "Close files",
  whatFiles: "the files",
  filesEmpty: "No files here yet. Files shared here, and Vantage's reports, show up in this list.",
  deleteFile: "Delete file",
  deleteFileTitle: "Delete {name}?",
  deleteFileBody:
    "It leaves every message that carried it (their words stay) and is erased, with its previews. This can't be undone.",
  fileDeleted: "Deleted {name}.",
  fileDeleteFailed: "Couldn't delete the file.",

  // The side panel: team notes.
  whatNotes: "the notes",
  whatTeamNotes: "the team notes",
  noNotes: "No team notes yet",
  notesListening:
    "As #{slug} talks, Vantage keeps its decisions, action items and open questions here.",
  notesNotListening: "Vantage isn't listening in #{slug}, so it keeps no notes here.",
  olderDone_one: "{n} older done note not shown.",
  olderDone_other: "{n} older done notes not shown.",
  decisions: "Decisions",
  actionItems: "Action items",
  openQuestions: "Open questions",
  agoMoment: "a moment ago",
  agoMin: "{n} min ago",
  agoHours: "{n} h ago",
  agoDays_one: "{n} day ago",
  agoDays_other: "{n} days ago",
  notesUpdated_one: "Updated {ago} · from {n} message today",
  notesUpdated_other: "Updated {ago} · from {n} messages today",
  noOwnerYet: "No owner yet",
  noteDone: "done",
  noteDue: "due {date}",
  askedAnswered: "Asked {at} · answered",
  openSince: "Open since {at}",
  editNote: "Edit note",
  showMessage: "Show the message",
  reopen: "Reopen",
  markDone: "Mark done",
  dismiss: "Dismiss",
  noteDismissed: "Note dismissed",
  noteChangeFailed: "Couldn't change that note.",
  noteRestoreFailed: "Couldn't bring the note back.",
  addANote: "Add a note",
  addNote: "Add note",
  noteAdded: "Note added",
  note: "Note",
  owner: "Owner",
  noOneYet: "No one yet",
  dueDate: "Due date",
  askAboutNotes: "Ask Vantage about these notes",
  notesQuestion: "Your question about these notes",
  notesQuestionPlaceholder: "What would you like to know about these notes?",
  ask: "Ask",
  couldntAsk: "Couldn't ask just now.",

  // Vantage's tables.
  nounTicket: "ticket",
  nounTickets: "tickets",
  nounPullRequest: "pull request",
  nounPullRequests: "pull requests",
  nounIssue: "issue",
  nounIssues: "issues",
  nounCommit: "commit",
  nounCommits: "commits",
  nounRun: "run",
  nounRuns: "runs",
  nounDoc: "doc",
  nounDocs: "docs",
  nounPerson: "person",
  nounPeople: "people",
  nounNote: "note",
  nounNotes: "notes",
  nounResult: "result",
  nounResults: "results",
  nounRow: "row",
  nounRows: "rows",
  countAll: "{n} {noun}",
  countOf: "{stored} of {n} {noun}",
  countPlus: "{stored}+ {noun}",
  showAll: "Show all {n}",
  firstThousand: "The first 1,000 of {n} are shown; Excel has them all.",
  allAsReport: "All {n} as a report",
  allAsReportTitle: "Let Vantage take its time and get every row",
  tableCopied: "Table copied",
  copyCode: "Copy code",

  // An admin's trace of a turn.
  trace: "Trace",
  whatTrace: "the trace",
  noModel: "no model",
  traceTokens: "{in} in · {out} out · {cached} cached",
  step: "Step",
  status: "Status",
  tokens: "Tokens",
  cost: "Cost",
  model: "Model",
  details: "Details",

  // A new chat.
  newChatAria: "New conversation with Vantage",
  hi: "Hi {name}, what can I look up?",
  newChatIntro:
    "Ask about tickets, pull requests, docs or people. I only use what you can see, and I'll say where each answer comes from.",
  starter1: "What changed in HoaVN last week?",
  starter2: "Which pull requests are waiting for review?",
  starter3: "Find the release checklist in Outline",

  // A channel that isn't there.
  channel: "Channel",
  channelGone: "This channel isn't available",
  channelGoneBody: "It may have been archived, or you're not in its team.",
};
